import { Link } from 'react-router-dom';
import type { TvShow } from '@/types/tv';
import ScoreBadge from '@/components/feature/ScoreBadge';

interface ShowCardProps {
  show: TvShow;
  showIntro?: boolean;
}

export default function ShowCard({ show, showIntro = false }: ShowCardProps) {
  return (
    <Link
      to={`/detail/${show.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={show.poster}
          alt={`${show.title}海报`}
          title={`${show.title} - 高评分电视剧`}
          className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2">
          <ScoreBadge score={show.score} />
        </div>
        <span className="absolute bottom-2 left-2 text-xs px-2 py-0.5 rounded-md bg-primary-950/80 text-background-100">
          {show.region}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base line-clamp-1 group-hover:text-primary-600 transition-colors">
          {show.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{show.year}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span className="line-clamp-1">{show.tags.slice(0, 2).join(' · ')}</span>
        </div>
        {showIntro && (
          <p className="mt-2 text-xs leading-relaxed text-foreground-500 line-clamp-2">
            {show.intro}
          </p>
        )}
      </div>
    </Link>
  );
}